import styled from "styled-components";
import { Route, Routes } from "react-router-dom";
import PostView from "./screens/PostView";
import LandingPage from "./screens/LandingPage";
import DeleteProfile from "./screens/DeleteProfileScreen";
import UserVibes from "./screens/UserVibes";
import UserDetailsScreen from "./screens/Admin/UserDetailsScreen";
import VerificatonWaitListUsers from "./screens/Admin/VerificatonWaitListUsers";
import VerificationScreen from "./WebView/VerificationScreen";
import VibeVenueDetails from "./WebView/VibeVenueDetails";
import BookingWebView from "./WebView/BookingScreen";
import GroupScreen from "./screens/GroupScreen";
import ProfileScreen from "./screens/ProfileScreen";
import PrivateRoute from "./PrivateRoute";
import LoginPage from "./screens/Admin/LoginScreen";
import LinkedInAuthScreen from "./WebView/LinkedinAuthScreen";
import LinkedInSuccessPage from "./WebView/LinkedinSuccess";
import IbPaymentScreen from "./screens/InvestorbookPayment";
import CreateEvent from "./screens/Admin/CreateEvent";
import AdminHome from "./screens/Admin/AdminHome";
import AddBanner from "./screens/Admin/Addbanner";
import BlockUser from "./screens/Admin/BlockUser";
import AdsDashboard from "./screens/AdsDashboard";
import AdsCreatorRoute from "./AdsCreatorRoute";
import CreatorsRedeemRequests from "./screens/Admin/CreatorsRedeemRequests";
import SpaceScreen from "./screens/SpaceScreen";
import MomentScreen from "./screens/MomentScreen";
import Privacy from "./screens/Privacy";
import Abuse from "./screens/Abuse";
import AdminReports from "./screens/Admin/AdminReports";
import PepRedeemRequests from "./screens/Admin/PepRedeemRequests";

function App() {
  return (
    <Container>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/post/:postId" element={<PostView />} />
        <Route path="/profile/:id" element={<ProfileScreen />} />
        <Route path="/uservibes/:id" element={<UserVibes />} />
        <Route path="/vibe/:id" element={<UserVibes kind="vibe" />} />
        <Route path="/plan/:id" element={<UserVibes kind="plan" />} />
        <Route path="/vibes/:id" element={<UserVibes kind="vibe" />} />
        <Route path="/plans/:id" element={<UserVibes kind="plan" />} />
        <Route path="/moments/:id" element={<MomentScreen />} />
        <Route path="/group/:id" element={<GroupScreen />} />
        <Route path="/space/:id" element={<SpaceScreen />} />
        <Route path="/delete-profile" element={<DeleteProfile />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/ads" element={<AdsDashboard />} />
        <Route path="/linkedin-auth" element={<LinkedInAuthScreen />} />
        <Route path="/linkedin-sucess" element={<LinkedInSuccessPage />} />
        <Route
          path="/admin/users"
          element={
            <PrivateRoute>
              <UserDetailsScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/users/:mobileNumber"
          element={
            <PrivateRoute>
              <UserDetailsScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/waitlist"
          element={
            <PrivateRoute>
              <VerificatonWaitListUsers />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/home"
          element={
            <PrivateRoute>
              <AdminHome />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/block-user"
          element={
            <PrivateRoute>
              <BlockUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/redeem-requests"
          element={
            <PrivateRoute>
              <CreatorsRedeemRequests />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/reports"
          element={
            <PrivateRoute>
              <AdminReports />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/pep-redeem-requests"
          element={
            <PrivateRoute>
              <PepRedeemRequests />
            </PrivateRoute>
          }
        />
        <Route
          path="/upload-ads"
          element={
            <AdsCreatorRoute>
              <AddBanner />
            </AdsCreatorRoute>
          }
        />
        <Route
          path="/ibpayments"
          element={
            <IbPaymentScreen />
          }
        />
        <Route path="/verify" element={<VerificationScreen />} />
        <Route path="/vibe-venue" element={<VibeVenueDetails />} />
        <Route
          path="/admin/create-event"
          element={
            <PrivateRoute>
              <CreateEvent />
            </PrivateRoute>
          }
        />
        <Route path="/booking" element={<BookingWebView />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/abuse" element={<Abuse />} />
      </Routes>
    </Container>
  )
}

const Container = styled.div`
  font-family: inherit;
  background-color: #000;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default App;
